export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'CommunicationEventConfig';
export const NAME = 'CommunicationEventConfiguration';
export const MODULE_API = 'Ciselniky';
export const EMAILRefText = <const>'EMAIL_REF_TEXT';
export const EmailAttachments = <const>'EmailAttachments';
export const DEPENDENT_TABLES = <const>[EmailAttachments];

export type DependentTableNames = typeof DEPENDENT_TABLES[number];
export enum BUSINESS_LINE {
	SALES = 'SALES',
	PRESALES = 'PRESALES'
}
export const EMAIL_ATTACHMENT_FILE_TYPE = 'application/pdf';
export const EMAIL_ATTACHMENT_FILE_MAX_SIZE = 2000000;
